export const DEFAULT_KEYS = {
  replay: 'r',
  next: 'd',
  previous: 'a',
  extend: ']',
  shrink: '[',
  togglePlay: ' ',
  cancelSelection: 'Escape',
} as const;

export const AUTO_PAUSE_TOLERANCE = 0.03;
export const AUTO_SCROLL_SUSPEND_MS = 1500;
export const PLAYER_WAIT_TIMEOUT_MS = 15_000;
export const TRACK_RESPONSE_TIMEOUT_MS = 4_000;
